import React from 'react';
import PropTypes from 'prop-types';
import { WarningTriangle } from 'AppSrc/core/components/common/svg-icons';
import {
  getCancelationReasonText,
} from 'AppSrc/core/crq/crq-status-reasons';
import 'AppSrc/core/style/components/form/cancelled-status-bar.css';


const getTitle = (cancellationData) => {
  if (!cancellationData) { return 'Cancelled'; }
  const {
    cancelledBy,
    date,
  } = cancellationData;
  return `Cancelled by ${cancelledBy} - ${date}`;
};

const CancelledStatusBar = React.memo(({
  selectedNetwork,
  statusReason,
  cancellationData,
}) => {

  const title = getTitle(cancellationData);
  const cancelledReasonText = getCancelationReasonText(selectedNetwork, statusReason);

  return (
    <div className="cancelled-status-bar-wrapper">
      <div className="cancelled-status-bar">
        <div className="warning-svg-wrapper">
          <div className="warning-svg">
            <WarningTriangle />
          </div>
        </div>
        <div className="cancelled-message">
          <h5 className="cancelled-title">
            {statusReason === '28000' ? '' : title}
          </h5>
          <p className="cancelled-reason">
            {cancelledReasonText ? cancelledReasonText : 'Unknown cancelled reason'}
          </p>
        </div>
      </div>
    </div>
  );
});


CancelledStatusBar.propTypes = {
  selectedNetwork: PropTypes.string,
  statusReason: PropTypes.string,
  cancellationData: PropTypes.objectOf(PropTypes.string),
};



export {
  CancelledStatusBar,
};
